const API = {
  endpoint: {
    web: process.env.REACT_APP_WEB_ENDPOINT,
    sales: process.env.REACT_APP_SALES_ENDPOINT,
    services: process.env.REACT_APP_API_ENDPOINT,
    cdn: process.env.REACT_APP_CDN_ENDPOINT,
    uploads: process.env.REACT_APP_API_UPLOADS
  },
  pagination: {
    items: 10
  },
  currency: {
    default: "ARS"
  },
  upload: {
    attachment_max_size: process.env.REACT_APP_ATTACHMENT_MAX_SIZE * 1024 * 1024,
    attachment_available_ext: ['.png', '.gif', '.jpg', '.jpeg', '.doc',
        '.xls', '.mpp', '.pdf', 'pptx', '.tiff', '.bmp', '.docx', '.xlsx',
        '.pptx', '.ps', '.odt', '.ods', '.odp', '.odg', '.csv', '.rar', '.zip', '.txt', '.mp4']
  }
};

export default API;
